<script lang="ts">
  import { t } from '../../i18n/index.svelte';
  import { sceneStore } from '../../scene/store.svelte';
  import type { Camera, Vec3 } from '../../scene/types';
  import Vec3Input from './Vec3Input.svelte';

  let { onfit }: { onfit: () => void } = $props();
  const cam = $derived(sceneStore.current.camera);

  function set<K extends keyof Camera>(k: K, v: Camera[K]) {
    sceneStore.update((d) => (d.camera[k] = v));
  }
  const num = (e: Event) => Number((e.currentTarget as HTMLInputElement).value);
</script>

<div class="props" data-testid="camera-props">
  <div class="seg">
    <button class:on={cam.projection === 'perspective'} onclick={() => set('projection', 'perspective')}
      >{t('scene.perspective')}</button
    >
    <button class:on={cam.projection === 'orthographic'} onclick={() => set('projection', 'orthographic')}
      >{t('scene.orthographic')}</button
    >
  </div>
  <Vec3Input label={t('scene.position')} value={cam.position} onchange={(v: Vec3) => set('position', v)} />
  <Vec3Input label={t('scene.target')} value={cam.target} onchange={(v: Vec3) => set('target', v)} />
  {#if cam.projection === 'perspective'}
    <label class="field inline"
      ><span>{t('scene.fov')}</span><input
        type="number"
        step="1"
        value={cam.fov}
        onchange={(e) => set('fov', num(e))}
      /></label
    >
  {:else}
    <label class="field inline"
      ><span>{t('scene.viewHeight')}</span><input
        type="number"
        step="0.5"
        value={cam.height}
        onchange={(e) => set('height', num(e))}
      /></label
    >
  {/if}
  <label class="field inline"
    ><span>{t('scene.near')}</span><input
      type="number"
      step="0.1"
      value={cam.near}
      onchange={(e) => set('near', num(e))}
      data-testid="cam-near"
    /></label
  >
  <label class="field inline"
    ><span>{t('scene.far')}</span><input
      type="number"
      step="0.1"
      value={cam.far}
      onchange={(e) => set('far', num(e))}
      data-testid="cam-far"
    /></label
  >
  <button onclick={onfit} title={t('scene.fitDepthHint')} data-testid="fit-depth">{t('scene.fitDepth')}</button>
  <p class="muted small">{t('scene.depthRangeHint')}</p>
</div>

<style>
  .props {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .field.inline {
    display: grid;
    grid-template-columns: 1fr 90px;
    align-items: center;
    font-size: 12px;
  }
  .field span {
    color: var(--muted);
  }
  input {
    padding: 3px 6px;
    font-size: 13px;
  }
  .small {
    font-size: 12px;
    margin: 0;
  }
</style>
